import { FC } from 'react';

import { Layout as AntdLayout, LayoutProps as AntdLayoutProps } from 'antd';

interface Layout extends AntdLayoutProps {}

export const Layout:FC<Layout> = (props) => <AntdLayout {...props} />;

export const {
  Content, Footer, Header, Sider,
} = AntdLayout;
